<template>

<com-segment class="stress" segment="stress" :section="section" v-on:close="$emit('close')">

	<div class="stress-head" v-if="!$isPatient">

		<div class="stress-head-text is-left">{{ section.stress.left }}</div>
		<div class="stress-head-text is-right">{{ section.stress.right }}</div>

	</div>

	<div class="stress-text" v-html="prepareText(section.stress.text)"></div>

	<com-links :links="section.stress.links" />

</com-segment>

</template>

<script>

import comSegment from './Segment'
import comLinks from './../common/Links'

export default {

	props: ['section', 'subsection'],

	components: {
		'com-segment': comSegment,
		'com-links': comLinks
	},

	methods: {

		prepareText: function(text) {

			text = text.replace(/{{bullet}}/g, '<span class="bullet"></span>')

			return text

		}

	}
	
}

</script>

<style scoped>

.stress-head {
	background-image: url(~@/assets/aid/improve/stress/head.svg);
	width: 243px;
	height: 292px;
	background-repeat: no-repeat;
	margin: 0px auto;
}

.stress-head-text {
	color: #343434;
	font-size: 22px;
	line-height: 26px;
	font-weight: 600;
	position: absolute;
	top: 120px;
	width: 140px;
}

.stress-head-text.is-left{
	right: 270px;
}

.stress-head-text.is-right {
	left: 260px;
}

.stress-text {
	color: #343434;
	font-size: 18px;
	padding: 0px 100px;
	line-height: 22px;
	font-weight: 400;
}

.stress-text >>> .bullet {
	width: 22px;
	height: 22px;
	display: inline-block;
	vertical-align: middle;
	background-size: contain;
	background-position: 0% 0px;
	background-repeat: no-repeat;
	background-size: 16px 16px;
	background-image: url(~@/assets/aid/common/bullet.png);
}

.is-patient .stress-text >>> .bullet {
	background-image: url(~@/assets/aid/common/link.png);
}

</style>
